export enum SciTheme {
  SCI = 'sci',
  PayForU = 'payforu',
  Light = 'light',
  SQ = 'sq',
}
